<template>
    <div class="table-action-btn" title="Удаление заявки">     
        <svg width="16" height="16" viewBox="0 0 108 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M93 18.2332H77.75V15C77.75 6.729 71.021 0 62.75 0H45.25C36.979 0 30.25 6.729 30.25 15V18.2332H15C6.729 18.2332 0 24.9622 0 33.2332V45.75H10V113C10 121.271 16.729 128 25 128H83C91.271 128 98 121.271 98 113V45.75H108V33.2332C108 24.9622 101.271 18.2332 93 18.2332ZM40.25 15C40.25 12.243 42.493 10 45.25 10H62.75C65.507 10 67.75 12.243 67.75 15V18.2332H40.25V15ZM88 113C88 115.757 85.757 118 83 118H25C22.243 118 20 115.757 20 113V45.75H88V113ZM98 35.75H10V33.2332C10 30.4762 12.243 28.2332 15 28.2332H93C95.757 28.2332 98 30.4762 98 33.2332V35.75Z" fill="black"/>
        </svg>
    </div>
</template>

<script>

export default {
    name: 'Btn_delete',

}

</script>

<style>
    .table-action-btn {
        display: inline-block;
         cursor: pointer;
         margin-left: 15px;
    }
</style>